import { Image } from "@ludens-reklame/rubics-v3-sdk/file/types";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import { RichText } from "../../internal-components/rich-text/richText.js";
import { Link } from "@ludens-reklame/rubics-v3-sdk/link/types";

interface Props {
  image?: Image;
  text?: string;
  textUnderImage?: string;
  button?: Link;
  imagePosition?: "left" | "right";
  variant?: "default" | "big";
  background?: "background" | "surface" | "surfaceVariant" | "secondary";
  hideCaption?: boolean;
}

const ImageAndText: React.FC<Props> = ({
  image,
  text,
  textUnderImage,
  button,
  imagePosition = "right",
  variant = "default",
  background,
  hideCaption,
}) => {
  return (
    <div className={`image-and-text ${background}`}>
      <div className="mw">
        <div
          className={`content
            ${imagePosition === "left" ? "image-left" : "image-right"}
            ${variant === "big" ? "big" : ""}
            `}
        >
          {text && (
            <div className="text">
              <RichText html={text} />
            </div>
          )}
          {image && (
            <div className="image">
              <img
                src={transformImageUrl(image, { width: 1120 })}
                alt={image.altText}
                style={{ aspectRatio: image.aspectRatio }}
              />
              {!hideCaption && image.caption && (
                <p className="caption b4">{image.caption}</p>
              )}
            </div>
          )}
          {textUnderImage && (
            <div className="text-under-image">
              <RichText html={textUnderImage} />
            </div>
          )}
        </div>

        {button && (
          <div className="btn-container">
            <a
              className="button"
              href={button.url}
              target={button.external ? "_blank" : "_self"}
            >
              {button.title}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageAndText;
